import { __rest } from "tslib";
import React from 'react';
export var Heading = function Heading(_a) {
  var type = _a.type,
    props = __rest(_a, ["type"]);
  return /*#__PURE__*/React.createElement(type, props);
};
export default Heading;